import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient.js";
import { useAuth } from "./auth.jsx";

export default function TrialJourney() {
  const { me } = useAuth();
  const [state, setState] = useState(null);
  const [hidden, setHidden] = useState(() => { try { return localStorage.getItem("tpms_journey_done") === "1"; } catch { return false; } });
  const [collapsed, setCollapsed] = useState(() => { try { return localStorage.getItem("tpms_journey_min") === "1"; } catch { return false; } });
  const [metPlan, setMetPlan] = useState(() => { try { return localStorage.getItem("tpms_journey_plan") === "1"; } catch { return false; } });

  const check = async () => {
    try {
      if (!me || me.role !== "admin") { setState(false); return; }
      const { data: prof } = await supabase.from("profiles").select("org_id,is_owner").eq("id", me.id).maybeSingle();
      if (!prof || prof.is_owner) { setState(false); return; }
      const { data: sub } = await supabase.from("subscriptions").select("status").eq("org_id", prof.org_id).maybeSingle();
      if (!sub || sub.status !== "trialing") { setState(false); return; }
      const [{ count: pubs }, { count: books }, { count: team }] = await Promise.all([
        supabase.from("rel_publishers").select("id", { count: "exact", head: true }).eq("org_id", prof.org_id),
        supabase.from("rel_books").select("id", { count: "exact", head: true }).eq("org_id", prof.org_id),
        supabase.from("profiles").select("id", { count: "exact", head: true }).eq("org_id", prof.org_id),
      ]);
      setState({ pubs: (pubs || 0) > 0, books: (books || 0) > 0, team: (team || 0) > 1 });
    } catch { setState(false); }
  };
  useEffect(() => { check(); const t = setInterval(check, 60000); const f = () => check();
    window.addEventListener("focus", f); return () => { clearInterval(t); window.removeEventListener("focus", f); };
  }, [me && me.id]);

  if (hidden || !state) return null;
  const steps = [
    { done: state.pubs, label: "أضيفوا جهتكم الأولى (دار نشر أو عميل)" },
    { done: state.books, label: "أنشئوا كتابكم أو مشروعكم الأول" },
    { done: state.team, label: "أنشئوا حسابًا لأحد أعضاء فريقكم" },
    { done: metPlan, label: "تعرفوا على باقتكم وما تشمله", action: true },
  ];
  const doneN = steps.filter((s) => s.done).length;
  const all = doneN === steps.length;
  if (all) {
    try { localStorage.setItem("tpms_journey_done", "1"); } catch {}
  }

  return (
    <div style={{ position: "fixed", bottom: 18, left: 18, zIndex: 850, width: collapsed ? "auto" : "min(330px, 92vw)", direction: "rtl",
      background: "color-mix(in srgb, var(--surface) 88%, transparent)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)",
      border: "1px solid var(--line)", borderRadius: 16, boxShadow: "0 14px 40px rgba(27,36,64,.18)", overflow: "hidden",
      fontFamily: "Tajawal, sans-serif", transition: "width .2s ease" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 15px", cursor: "pointer",
        borderBottom: collapsed ? "none" : "1px solid var(--line)" }}
        onClick={() => { const v = !collapsed; setCollapsed(v); try { localStorage.setItem("tpms_journey_min", v ? "1" : "0"); } catch {} }}>
        <b style={{ fontSize: 14, color: "var(--text)" }}>رحلة البداية</b>
        <span style={{ fontSize: 12, fontWeight: 800, color: "var(--accent)" }}>{doneN}/{steps.length}</span>
        <span style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: "var(--faint)" }}>{collapsed ? "فتح" : "طي"}</span>
      </div>
      {!collapsed && (
        <div style={{ padding: "12px 15px 14px" }}>
          <div style={{ height: 6, borderRadius: 99, background: "var(--line)", overflow: "hidden", marginBottom: 12 }}>
            <div style={{ width: (doneN / steps.length) * 100 + "%", height: "100%", borderRadius: 99, background: "var(--accent)", transition: "width .4s ease" }} />
          </div>
          {steps.map((st, i) => (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 9, padding: "6px 0", fontSize: 13, fontWeight: 700,
              color: st.done ? "var(--faint)" : "var(--text)" }}>
              <span style={{ width: 18, height: 18, borderRadius: 99, flexShrink: 0, display: "inline-flex", alignItems: "center", justifyContent: "center",
                fontSize: 11, fontWeight: 900, border: "1.5px solid " + (st.done ? "var(--accent)" : "var(--line)"),
                background: st.done ? "var(--accent)" : "transparent", color: st.done ? "var(--bg)" : "var(--faint)" }}>{st.done ? "✓" : i + 1}</span>
              <span style={{ textDecoration: st.done ? "line-through" : "none", lineHeight: 1.6 }}>
                {st.label}
                {st.action && !st.done && (
                  <button onClick={() => { setMetPlan(true); try { localStorage.setItem("tpms_journey_plan", "1"); } catch {} try { window.dispatchEvent(new CustomEvent("tpms:open-mysub")); } catch {} }}
                    style={{ display: "block", marginTop: 4, fontFamily: "inherit", fontSize: 12, fontWeight: 800, padding: "4px 12px", borderRadius: 9,
                      border: "1px solid var(--accent)", background: "transparent", color: "var(--accent)", cursor: "pointer" }}>عرض باقتنا</button>
                )}
              </span>
            </div>
          ))}
          {all && <div style={{ marginTop: 10, fontSize: 13, fontWeight: 800, color: "var(--accent)" }}>أتممتم الرحلة - نظامكم جاهز للعمل الحقيقي.</div>}
        </div>
      )}
    </div>
  );
}
